/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('thingsboard.api.unit', [])
    .factory('unitService', UnitService)
    .name;


const celciusPostFuncBody = 'return value;';

const fahrenheitPostFuncBody = 'if ((typeof value === undefined) || value == null) ' +
    '{ ' +
    'return value; ' +
    '} ' +
    'else { ' +
    'var result = (value * 1.8) + 32;' +
    'return parseFloat((result).toFixed(3));' +
    '}';

const absoluteFahrenheitPostFuncBody = 'if ((typeof value === undefined) || value == null) ' +
    '{ ' +
    'return value; ' +
    '} ' +
    'else { ' +
    'var result = value * 1.8;' +
    'return parseFloat((result).toFixed(3));' +
    '}';

/*@ngInject*/
function UnitService(types) {

    var temperatureUnit = types.tempUnits.celsius.value;

    var service = {
        updateTemperatureUnit: updateTemperatureUnit,
        getTemperatureUnit: getTemperatureUnit,
        moistureUnitSymbol: moistureUnitSymbol,
        co2UnitSymbol: co2UnitSymbol,
        temperatureUnitSymbol: temperatureUnitSymbol,
        toUserTemperature: toUserTemperature,
        fromUserTemperature: fromUserTemperature,
        temperaturePostprocessingFuncBody: temperaturePostprocessingFuncBody
    };

    return service;

    function updateTemperatureUnit(newTemperatureUnit) {
        temperatureUnit = newTemperatureUnit;
    }

    function getTemperatureUnit() {
        return temperatureUnit;
    }

    function moistureUnitSymbol() {
        return '%';
    }

    function co2UnitSymbol() {
        return 'ppm';
    }

    function temperatureUnitSymbol() {
        return types.tempUnits[temperatureUnit].symbol;
    }

    function toUserTemperature(temperature, absolute) {
        if (temperatureUnit === types.tempUnits.celsius.value) {
            return temperature;
        } else {
            if (angular.isUndefined(temperature) || temperature == null) {
                return temperature;
            } else {
                //from celsius to fahrenheit
                var result = temperature * 1.8;
                if (!absolute) {
                    result += 32;
                }
                return round(result);
            }
        }
    }

    function fromUserTemperature(temperature, absolute) {
        if (temperatureUnit === types.tempUnits.celsius.value) {
            return temperature;
        } else {
            if (angular.isUndefined(temperature) || temperature == null) {
                return temperature;
            } else {
                //from fahrenheit to celsius\
                var result = temperature;
                if (!absolute) {
                    result -= 32;
                }
                return round(result / 1.8);
            }
        }
    }

    function temperaturePostprocessingFuncBody(absolute) {
        if (temperatureUnit === types.tempUnits.celsius.value) {
            return celciusPostFuncBody;
        } else {
            if (absolute) {
                return absoluteFahrenheitPostFuncBody;
            } else {
                return fahrenheitPostFuncBody;
            }
        }
    }

    function round(value) {
        return parseFloat((value).toFixed(3));
    }
}